exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-honey-js": () => import("./../../../src/pages/honey.js" /* webpackChunkName: "component---src-pages-honey-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-norman-js": () => import("./../../../src/pages/norman.js" /* webpackChunkName: "component---src-pages-norman-js" */)
}

